<div class="not-found text-center">
    <img src="assets/img/not-found.gif" class="mb-25" alt="not-found">
    <h4 class="mb-15">Oops!! The page you are looking for doesn't exist!</h4>
    <p class="ms-auto me-auto mb-25  ">The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
    <a class="tagus mt-20 px-4 py-4 dashboard-btn" href="/agent/dashboard">Back to Portal</a>
</div>